import React from 'react';

import { captureException } from '@sentry/react';
import { useRouteError } from 'react-router-dom';

import UnavailablePage from '../../pages/unavailable/unavailable.page';

type RouteBoundaryProps = {
  fallback?: React.ReactElement;
};

export const RouteErrorBoundary = ({
  fallback = <UnavailablePage />,
}: RouteBoundaryProps) => {
  const error = useRouteError();

  captureException(error, {
    tags: { feature: 'insights' },
  });

  return fallback;
};
